import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

const BimIcon: React.FC = () => (
    <SvgIcon fontSize='small' viewBox='0 0 21 20'>
        <path
            d='M15.0001 12.4948C16.7738 11.6522 18.0001 9.8443 18.0001 7.75C18.0001 4.8505 15.6496 2.5 12.7501 2.5C9.85063 2.5 7.50012 4.8505 7.50012 7.75C7.50012 9.8443 8.72641 11.6522 10.5001 12.4948V17.5H15.0001V12.4948Z'
            fill='#C7CAD4'
        />
        <path
            d='M6.75 5.50003C6.8942 5.50003 7.03651 5.50817 7.17648 5.52402C6.90134 6.21231 6.75 6.96348 6.75 7.75C6.75 9.58941 7.57771 11.2355 8.881 12.3361C8.68358 12.4727 8.47241 12.5908 8.25 12.688V16H5.25V12.688C3.92557 12.1093 3 10.7878 3 9.25003C3 7.17896 4.67893 5.50003 6.75 5.50003Z'
            fill='#C7CAD4'
        />
    </SvgIcon>
)
export default BimIcon
